import React from 'react'
import "./SectionOne.css"
const SectionOne = () => {
  return (
    <div className='section'>

    <div className='SectionOne'>
        <div className='s1_img1'>
        <img src='https://ableton-production.imgix.net/about/photo-1.jpg?auto=format&dpr=2&fit=crop&fm=jpg&h=454&ixjsv=1.1.3&q=50&w=500' alt=''/>

        </div>
        <div className='s1_img2'>
        <img src='https://ableton-production.imgix.net/about/photo-2.jpg?auto=format&dpr=2&fit=crop&fm=jpg&h=454&ixjsv=1.1.3&q=50&w=500' alt=''/>

        </div>
        <div className='s1-bgc'></div>
    </div>
    </div>
    
  )
}

export default SectionOne